import * as React from 'react';
import injectSheet from 'react-jss';
import { Select, Button, Modal, Row, Col, Radio, Icon, Checkbox } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setFilter, applyFilter } from 'src/actions/inquiryShipperActionsBids';
import { globalShippingLines, globalAirlines } from 'src/selectors/importsFilter';
import { InquiryModes } from 'src/Library/Constants';
import { tokens } from 'src/design-system';

const Option = Select.Option;

const styles = theme => ({
  modal: {
    minWidth: '78%',
    '& .ant-modal-footer': {
      paddingTop:'0%',
      display: 'flex !important',
      marginLeft: '0.8% !important',
      border: 'none',
    },
    '& .ant-btn-primary': {
      backgroundColor: '#1875F0',
      border: '#1875F0',
    },
    position: 'absolute',
    marginTop: '1% !important',
  },
  bidFiltermsg: {
    fontSize: `${tokens.fontSize.caption}px`,
    color: 'FFC104',
    fontStyle: 'italic',
  },
  infoIcon: {
    color: '#FFC104',
    marginRight: '5px',
    fontSize: `${tokens.fontSize.small}px`,
  },
  ffType: {
    backgroundColor: '#FFE7D5',
    border: '1px solid #FFC59A',
    padding: '0px 4px',
    marginLeft: '5px',
    fontSize: `${tokens.fontSize.caption}px`,
    borderRadius: `${tokens.radius.sm}px`,
  },
  groupType: {
    backgroundColor: '#EDE3FC',
    border: '1px solid #A082CE',
    padding: '0px 4px',
    marginLeft: '5px',
    fontSize: `${tokens.fontSize.caption}px`,
    borderRadius: `${tokens.radius.sm}px`,
  },
});

const bidsFilterOptions = [
  { label: 'Self Raised', value: 'SELF' },
  { label: 'Others', value: 'OTHER' },
];
class ShipperBidsFilterModal extends React.PureComponent<any, any> {
  state: any = {
    statusValue: '',
  };

  options = () => {
    const { globalCarrierLines } = this.props;
    const children: any = [];
    globalCarrierLines.map((carrierLine) => {
      children.push(<Option key={carrierLine.id}>{carrierLine.name}</Option>);
    });
    return children;
  }

  componentDidMount = () => {
    this.setState({
      statusValue: (this.props.filters.bidStatusList && this.props.filters.bidStatusList[0])
      || 'ACTIVE',
    });
  }

  ffoptions = () => {
    const { FF, ffGroups, classes, inquiryMode } = this.props;
    const ffAndGroupsList = [...FF.map(ff => ({ ...ff, isGroup: false })), ...ffGroups.map(ff => ({ ...ff, isGroup: true }))];
    const ffType = inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.TRAILER ? 'Trucker' : 'FF';
    return ffAndGroupsList.map((ff) => <Option key={ff.id}>
      <div style={{display:'flex', justifyContent: 'space-between'}}>
        <span>{ff.name}</span>
        <span className={ff.isGroup ? classes.groupType : classes.ffType}>{ff.isGroup ? 'Group' : ffType }</span>
        </div>
        </Option>);
  }

  onChange = (event) => {
    let bidStatus;
    if (event.target.value === 'DELETED') {
      this.setState({ statusValue: 'DELETED' });
      bidStatus = ['DELETED'];
    } else {
      this.setState({ statusValue: 'ACTIVE' });
      bidStatus = ['ACTIVE'];
    }
    this.props.setFilter({
      bidStatusList: bidStatus,
    });
  }

  render() {
    const { visible, handleOk, handleCancel, classes, filters, compareBidModal,
     inquiryMode, ffGroups } = this.props;
    const dropdown = { maxWidth: '240px' };
    const selectLabel = (inquiryMode === 'AIRCARGO' ? 'Carriers' : 'Shipping Lines');
    return (
      <Modal
        className={classes.modal}
        visible={visible}
        mask={false}
        onCancel={() => {
          handleCancel();
        }}
        onOk={handleOk}
        okText="Apply"
        closable={false}
        style={{ marginLeft: compareBidModal ? '19%' : '21%',
          top: compareBidModal ? '42px' : undefined }}
        footer={[
          <Button key="submit" type="primary" style={{ marginLeft: '16%',
            background: tokens.colors.primary, border: tokens.colors.primary }}
            data-testid={'apply-filter'}
            onClick={handleOk}>
            Apply
            </Button>,
          <Button key="back" onClick={() => handleCancel()}>
            Cancel
            </Button>,
        ]}
      >
        {![InquiryModes.TRAILER, InquiryModes.DOMESTIC].includes(inquiryMode) && <Row style={{ padding: '2px 0px' }}>
          <Col span={4}>
            <span style={{ padding: '0px 10px 0px', lineHeight: '2' }}>{selectLabel}</span>
          </Col>
          <Col span={19}>
            <Select
              showSearch
              mode="multiple"
              placeholder={`Search & Select ${selectLabel}`}
              onChange={shippingLines =>
                this.props.setFilter({ shippingLineList: shippingLines })}
              value={this.props.filters.shippingLineList}
              dropdownStyle={dropdown}
              style={{ minWidth: '33%' }}
            >
              {this.options()}
            </Select>
          </Col>
        </Row>}
        <Row style={{ padding: '2px 0px', marginTop: '6px' }}>
          <Col span={4}>
            <span style={{ padding: '0px 10px', lineHeight: '2' }}>
              {[InquiryModes.TRAILER, InquiryModes.DOMESTIC].includes(inquiryMode) ? 'Trucker' : 'FF'}
            </span>
          </Col>
          <Col span={19}>
            <Select
              showSearch
              mode="multiple"
              placeholder={`Search & Select ${[InquiryModes.TRAILER, InquiryModes.DOMESTIC].includes(inquiryMode) ? 'Truckers' : 'Freight Forwarders'}`}
              onChange={(ffs) => {
                const { FF, ffGroups } = this.props;
                const ffIds = ffs.filter(ff => FF.find(ffId => ffId.id === ff))
                const ffGroupIds = ffs.filter(ff => ffGroups.find(ffId => ffId.id === ff))
                this.props.setFilter({ ffIdList: ffIds, ffGroupIdList: ffGroupIds})
              }}
              value={[...(this.props.filters?.ffIdList || []), ...(this.props.filters?.ffGroupIdList || [])]}
              dropdownStyle={dropdown}
              style={{ minWidth: '33%' }}
              data-testid={'ff-select'}
            >
              {this.ffoptions()}
            </Select>
          </Col>
        </Row>
        <Row style={{ padding: '2px 0px', marginTop: '6px' }}>
          <Col span={4}>
            <span style={{ padding: '0px 10px', lineHeight: '2' }}>Bid Type</span>
          </Col>
          <Col span={19}>
            <Checkbox.Group options={bidsFilterOptions}
              value={filters.bidsTypeList}
              onChange={(checkedValues) => {
                this.props.setFilter({
                  bidsTypeList: checkedValues,
                });
              }} />
          </Col>
        </Row>
        {/* <Row style={{ padding: '2px 0px', marginTop: '6px' }}>
          <Col span={4}>
            <span style={{ padding: '0px 10px', lineHeight: '2' }}>Show Bids</span>
          </Col>
          <Col span={19}>
            <Checkbox
              checked={filters.showPreSelectedBids}
              disabled={this.props.isCompareBids}
              onChange={e => {
                this.props.setFilter({
                  showPreSelectedBids: e.target.checked,
                });
              }}
            >Pre-selected bids only</Checkbox>
          </Col>
        </Row> */}
        <Row style={{ padding: '2px 0px', margin: '6px 0px 0px 10px' }}>
          <Col>
            <Radio.Group
              onChange={this.onChange} value={this.state.statusValue}>
              <Radio value="ACTIVE" disabled={this.props.isCompareBids}
              >Active</Radio>
              <Radio value="DELETED" disabled={this.props.isCompareBids}
              >Deleted</Radio>
            </Radio.Group>
          </Col>
          {this.props.isCompareBids ? <div style={{ marginTop: '10px' }}>
            <Icon type="info-circle" theme="filled" className={classes.infoIcon} />
            <span className={classes.bidFiltermsg}>
              Bid Comparison is available for Active bids only</span></div> : undefined}
        </Row>
        <br />
      </Modal>
    );
  }
}

const mapStateToProps = ({ masterData, inquiryShipperBidsReducer }, { inquiryMode }) => {
  return {
    inquiryMode,
    globalCarrierLines: inquiryMode === 'AIRCARGO'
      ? globalAirlines(masterData)
      : globalShippingLines(masterData),
    FF: masterData.dimensionData.FF,
    ffGroups: masterData.dimensionData?.FF_GROUPS,
    filters: inquiryShipperBidsReducer.selectedFilters,
  };
};

const mapDispatchToProps = dispatch => (bindActionCreators({
  setFilter,
  applyFilter,
}, dispatch));

export default
  injectSheet(styles)(connect(mapStateToProps, mapDispatchToProps)(ShipperBidsFilterModal));
